export default {
  label: {
    id: 'bo_sellers-orders-sub_views-number_of_orders',
    defaultMessage: 'Number of orders',
  },
} as const
